import React from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '~/redux/root-reducer';
import {MENOPAUSAL_PROFILE_TEST_KEYS} from '~/constants/medical-questionnaires';
import Questionnaire1Screen from '~/pages/homes/menopausal-profile-test/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/menopausal-profile-test/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/menopausal-profile-test/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/menopausal-profile-test/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/menopausal-profile-test/Questionnaire5Screen';
import {trackPageViewGA} from '~/services/google-analytics';

const MenopausalProfileTest = () => {
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case MENOPAUSAL_PROFILE_TEST_KEYS.START:
        trackPageViewGA('/menopausal-profile-test/start', 'MDQ-Menopausal Profile Test - Start');
        return <Questionnaire1Screen />;
      case MENOPAUSAL_PROFILE_TEST_KEYS.PROFILE:
        trackPageViewGA('/menopausal-profile-test/profile', 'MDQ-Menopausal Profile Test - Profile');
        return <Questionnaire2Screen />;
      case MENOPAUSAL_PROFILE_TEST_KEYS.INVALID:
        trackPageViewGA('/menopausal-profile-test/invalid', 'MDQ-Menopausal Profile Test - Invalid');
        return <Questionnaire3Screen />;
      case MENOPAUSAL_PROFILE_TEST_KEYS.APPOINTMENT_PREFERENCES:
        trackPageViewGA(
          '/menopausal-profile-test/appointment-preferences',
          'MDQ-Menopausal Profile Test - Appointment Preferences',
        );
        return <Questionnaire4Screen />;
      case MENOPAUSAL_PROFILE_TEST_KEYS.YOUR_TEST_PACKAGE:
        trackPageViewGA(
          '/menopausal-profile-test/your-test-package',
          'MDQ-Menopausal Profile Test - Your Test Package',
        );
        return <Questionnaire5Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default MenopausalProfileTest;
